import { SwiperSlide } from "swiper/react";
import { Container, Title, Carousel } from "../../shared/ui";
import { useMediaQuery } from "../../shared/hooks/useMediaQuery";
import { generateMediaQuery } from "../../shared/lib/helpers";
import { MediaQueryProperty, MediaSizeEnum } from "../../shared/constants/media";
import { HotVacancyCard } from "../../entities/Vacancy";
import { useGetHotVacanciesQuery } from "../../entities/Vacancy/api/vacancyApi";
import {
    Hot1,
    Hot2,
    Hot3,
    Hot4,
    Hot5,
    Hot6,
    Hot7,
    Hot8,
    Hot9,
    Hot10,
    Hot11,
    Hot12,
} from "../../shared/assets/img";

import styles from "./HotVacancies.module.scss";
import { getRouteVacancy } from "../../shared/constants/routes";
import { CSSProperties, useMemo } from "react";

export const HotVacancies = () => {
    const isMobile = useMediaQuery(generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.sm));

    const { data: hotVacancies } = useGetHotVacanciesQuery();

    const placeholders = useMemo(() => [
        Hot1,
        Hot2,
        Hot3,
        Hot4,
        Hot5,
        Hot6,
        Hot7,
        Hot8,
        Hot9,
        Hot10,
        Hot11,
        Hot12,
    ], []);

    const randomizedBackgrounds = useMemo(() => {
        if (!hotVacancies || hotVacancies.length === 0) return [] as string[];

        const STORAGE_KEY = "hotVacanciesIconOrderV1";

        let order: number[] | null = null;
        if (typeof window !== "undefined") {
            try {
                const raw = sessionStorage.getItem(STORAGE_KEY);
                const parsed = raw ? (JSON.parse(raw) as number[]) : null;
                if (Array.isArray(parsed) && parsed.length === placeholders.length) {
                    order = parsed;
                }
            } catch {
                order = null;
            }
        }

        if (!order) {
            order = Array.from({ length: placeholders.length }, (_, i) => i);
            for (let i = order.length - 1; i > 0; i -= 1) {
                const j = Math.floor(Math.random() * (i + 1));
                [order[i], order[j]] = [order[j], order[i]];
            }
            if (typeof window !== "undefined") {
                try {
                    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(order));
                } catch {
                    // ignore
                }
            }
        }

        const result: string[] = [];
        for (let k = 0; k < hotVacancies.length; k += 1) {
            const iconIndex = order[k % order.length];
            const icon = placeholders[iconIndex];
            if (k > 0 && result[k - 1] === icon) {
                const nextIconIndex = order[(k + 1) % order.length];
                result.push(placeholders[nextIconIndex]);
            } else {
                result.push(icon);
            }
        }
        return result;
    }, [hotVacancies, placeholders]);

    const slides = hotVacancies?.map((vacancy, index) => (
        <SwiperSlide key={vacancy.id} className={styles.slide}>
            <HotVacancyCard {...vacancy} to={getRouteVacancy(vacancy.id!)} background={randomizedBackgrounds[index]} />
        </SwiperSlide>
    ));

    return (
        <Container marginSize={!isMobile ? "standard" : undefined} className={styles.container}>
            <Title className={styles.title} level={3}>
                Горячие вакансии
            </Title>
            <div className={styles.swiper}>
                <Carousel
                    spaceBetween={isMobile ? 0 : 20}
                    slidesOffsetBefore={isMobile ? 20 : 0}
                    slidesOffsetAfter={isMobile ? 20 : 0}
                    loop={false}
                    navigation="down"
                    navigationTheme="light"
                    className={styles.carousel}
                    style={{ "--space-between-slide": isMobile ? "0" : "20px" } as CSSProperties}
                >
                    {slides}
                </Carousel>
            </div>
        </Container>
    );
};
